export const kfUrl = "https://work.weixin.qq.com/kfid/kfc346f1f770a3a6a6f" //微信客服地址
export const webIcon = require('../../public/favicon1.png')
export const gwUrl =  process.env.VUE_APP_WEBURL
/**
 * 
 * @param {*} target   默认_blank
 * _blank在新窗口或选项卡中打开链接文档,_self 在与点击相同的框架中打开链接的文档（默认）。
 */
export function downloadA(url, target = '_blank') {
    if(!url) return
    const dowa = document.createElement('a');
    // dowa.href = this.navbannerList[index].url
    dowa.href = url
    dowa.target = target
    document.body.appendChild(dowa);
    dowa.click();
    document.body.removeChild(dowa);
}
export function callApp(schema, timeOut) {
    let timer, start = new Date().getTime();
    let myPromise = new Promise((resolve, reject) => {
        window.location.href = schema;
        window.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden') {
                clearTimeout(timer);
                resolve();
            };
        });
        timer = setTimeout(() => {
            let end = new Date().getTime();
            if (end - start > timeOut + 1000) {
                clearTimeout(timer);
                resolve();
            } else {
                reject();
            };
        }, timeOut);
    })
    return myPromise
}
export function location(url) {
    window.location.href = url;
}